import _objectSpread from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { popUp, commonData } from "@/mixins/index";
export default {
  mixins: [popUp, commonData],
  data: function data() {
    return {
      dialogFormVisible: false,
      formData: {
        id: "",
        appid: "",
        realname_config_id: ""
      },
      rules: {
        appid: [{
          required: true,
          message: "请选择应用",
          trigger: "blur"
        }],
        realname_config_id: [{
          required: true,
          message: "请选择类型",
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.getcommonData(['appListAllData', 'appRealnameAuthConfigTypeDataAll']);

              case 2:
                _this.copyPrimitive();

                if (data) {
                  _this.formData = _objectSpread({}, data);
                }

                _this.copyData();

                _this.dialogFormVisible = true;

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this2 = this;

      this.$refs.ruleForm.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(valid) {
          var reqFn;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!valid) {
                    _context2.next = 6;
                    break;
                  }

                  if (!_this2.formData.id) {
                    _context2.next = 4;
                    break;
                  }

                  _context2.next = 4;
                  return _this2.secondConfirmation();

                case 4:
                  reqFn = _this2.formData.id ? 'appRealnameAuthConfigUpdate' : 'appRealnameAuthConfigAdd';

                  _this2.$api[reqFn](_objectSpread(_objectSpread({}, _this2.formData), {}, {
                    isMustAppid: 1
                  })).then(function (res) {
                    if (res.status == 200) {
                      _this2.$message({
                        message: '操作成功',
                        type: 'success'
                      });

                      _this2.dialogFormVisible = false;

                      _this2.$emit('change');
                    }
                  });

                case 6:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
};